import { Model } from 'app/model/backendmodel';
import { IFile } from 'app/interfaces/IFile';
import { ModelService } from 'app/model/services/model.service';
import { format } from 'app/shared/utils/string.util';
import { AdapterContext, Factory, IResourceContext, ModelUtilties } from 'shell-models-lib';
import { PublishConfigService } from 'app/model/services/publisher/publish-config.service';

export class AssetUtils {
    private static readonly prePostDeploymentScriptFullTemplateModule = require('cmd-api/assets/PrePostDeploymentScriptSkipTriggerStop.ps1');
    private static readonly globalParametersUpdateScriptModule = require('cmd-api/assets/GlobalParametersUpdateScript.ps1');
    private static readonly prePostDeploymentScriptFileName = 'PrePostDeploymentScript.ps1';
    private static readonly globalParametersUpdateScriptFileName = 'GlobalParametersUpdateScript.ps1';
    private static readonly globalParametersFileName = '{0}_GlobalParameters.json';

    public static async getDeploymentHelperFiles(contextData: IResourceContext, usePreviewTools: boolean, services: { modelService: ModelService, publishConfigService: PublishConfigService }): Promise<IFile[]> {
        const files = [];
        files.push(AssetUtils.getScriptAsFile(AssetUtils.prePostDeploymentScriptFullTemplateModule, AssetUtils.prePostDeploymentScriptFileName));
        files.push(AssetUtils.getScriptAsFile(AssetUtils.globalParametersUpdateScriptModule, AssetUtils.globalParametersUpdateScriptFileName));
        files.push(AssetUtils.convertJsonToFile(await AssetUtils.getGlobalParametersObject(contextData, services.modelService.factory), format(AssetUtils.globalParametersFileName, services.modelService.factory.name)));
        return files.filter((f) => !!f);
    }

    private static async getGlobalParametersObject(contextData: IResourceContext, factory: Factory): Promise<{}> {
        const factoryResource = await ModelUtilties.toResource(AdapterContext.defaultContextOf(contextData), factory) as Model.Factory;
        return factoryResource?.properties?.globalParameters || {};
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private static getScriptAsFile(scriptModule: any, fileName: string): IFile {
        if (scriptModule?.default) {
            return {
                payload: scriptModule.default,
                fileName
            };
        }
        return null;
    }

    private static convertJsonToFile(payload: {}, fileName: string): IFile {
        return {
            payload: JSON.stringify(payload, null, '\t'),
            fileName
        };
    }
}
